import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Grid } from '../..';
export const title = 'Guides';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "guides"
    }}>{`Guides`}</h1>
    <Grid sx={{
      a: {
        display: 'block',
        fontWeight: 'bold',
        fontSize: 3,
        textDecoration: 'none'
      }
    }} mdxType="Grid">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/css-grid"
          }}>{`CSS Grid`}</a>{`
Use the Rebass Box component and `}<inlineCode parentName="li">{`sx`}</inlineCode>{` prop to create custom CSS Grid components`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/mdx"
          }}>{`MDX`}</a>{`
Use Rebass components to add styles and layout to MDX documents`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/using-rebass-without-context"
          }}>{`Using Rebass without Context`}</a>{`
Create self-contained components that do not require theming context`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/server-side-rendering"
          }}>{`Server-Side Rendering`}</a>{`
Render Rebass components on the server with zero configuration`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/styled-components"
          }}>{`Styled Components`}</a>{`
Use Rebass with the Styled Components library`}</li>
      </ul>
    </Grid>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      